/**
 * VendaDeleteDialog Component - Confirmação de Exclusão de Venda
 */

import { GenericDeleteDialog } from "@/components/ui/generic-delete-dialog";
import { Venda } from "@/types/venda";

interface VendaDeleteDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  venda: Venda | null;
  onConfirm: () => void;
  isLoading: boolean;
}

export function VendaDeleteDialog({
  open,
  onOpenChange,
  venda,
  onConfirm,
  isLoading,
}: VendaDeleteDialogProps) {
  return (
    <GenericDeleteDialog
      open={open}
      onOpenChange={onOpenChange}
      item={venda}
      onConfirm={onConfirm}
      isLoading={isLoading}
      entityName="Venda"
      getItemLabel={(v) => `#${v.numero_venda}`}
    />
  );
}
